<template>

    <li class="portfolio-item project"
        :class="'size-' + tiles"
    >
        <router-link :to="link">

            <div class="project-logo">
                <img :src="logo" :alt="link">
            </div>

            <div class="preview">
                <img :src="preview" :alt="link + ' Preview'">
            </div>

        </router-link>

        <span class="blender-1" :style="{ background }"></span>

        <span class="blender-2" :style="{ background }"></span>

    </li>

</template>

<script>
import { EventBus } from '@/main'
export default {

    props: {
        link: {
            type: String,
            required: true
        },
        background: {
            type: String,
            required: true
        },
        logoSuffix: {
            type: String,
            default: 'png'
        },
        tiles: {
            type: String,
            required: true
        }
    },

    computed: {
        logo() {
            return require('Projects/' + this.link.toLowerCase().replace(/\s/g, '-') + '/project-logo.' + this.logoSuffix)
        },
        preview() {
            return require('Projects/' + this.link.toLowerCase().replace(/\s/g, '-') + '/project-preview.jpg')
        }
    }

}
</script>



// WEBPACK FOOTER //
// project-internal.vue?2c030d7a